export type TileImageFormat = 'jpeg' | 'webp';

/** Global default; override per scene via VITE_WEBP_SCENES (comma-separated scene ids). */
export function tileFormatForScene(sceneId: string): TileImageFormat {
  const envDefault = import.meta.env.VITE_TILE_FORMAT as string | undefined;
  const webpScenes = new Set(
    String(import.meta.env.VITE_WEBP_SCENES ?? '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  );
  if (webpScenes.has(sceneId)) return 'webp';
  if (envDefault === 'webp') return 'webp';
  return 'jpeg';
}

export function withTileFormat(path: string, format: TileImageFormat): string {
  if (format === 'jpeg') return path;
  return path.replace(/\.jpg$/i, '.webp');
}
